import { useEffect, useMemo, useState } from 'react';
import { useLazyGetRoleByIdQuery } from '../../../../../services/adminApi';
import { useGetAllDocumentTypesQuery } from '../../../../../services/documentsApi';
import { handleErrors } from '../../../../../utils/functions';

function useRolesShow({ selectedItem, drawerAction }: any) {
    const [data, setData] = useState<any>(null);
    const [getRoleById, { isLoading: loadingRoleById, isFetching: fetchingRoleById }] =
        useLazyGetRoleByIdQuery();

    const {
        data: allDocumentTypes,
        isLoading: loadingAllDocumentTypes,
        isFetching: fetchingAllDocumentTypes
    } = useGetAllDocumentTypesQuery(
        {},
        { refetchOnMountOrArgChange: false, skip: drawerAction !== 'view' }
    );

    useEffect(() => {
        if (selectedItem && drawerAction === 'view' && !!allDocumentTypes?.length) {
            loadData();
        }
        // eslint-disable-next-line
    }, [selectedItem, drawerAction, allDocumentTypes]);

    const loadData = async () => {
        const response: any = await getRoleById(selectedItem?.id).unwrap();
        if (!response.error) {
            setData({ ...response, permisos: getPermissions(response?.permisos) });
        } else {
            handleErrors(response.error);
        }
    };

    const getPermissions = (permissions: any) => {
        return permissions?.map((permission: any) => ({
            id: Number(permission.tipoDocumento.id),
            cargar: permission.cargar,
            descargar: permission.descargar,
            eliminar: permission.eliminar,
            tipoDocumento: allDocumentTypes?.find(
                (ed: any) => ed.tipoDocumento.id === Number(permission.tipoDocumento.id)
            )?.tipoDocumento
        }));
    };

    const clearData = () => setData(null);

    const loading = useMemo(
        () =>
            loadingRoleById ||
            fetchingRoleById ||
            loadingAllDocumentTypes ||
            fetchingAllDocumentTypes,
        [loadingRoleById, fetchingRoleById, loadingAllDocumentTypes, fetchingAllDocumentTypes]
    );

    return { allDocumentTypes, data, loading, clearData };
}

export default useRolesShow;
